'use strict';
import angular from 'angular';

const ExportBuilderPublishConstants = {
    PUBLISH_MODAL_ID: 'report-studio-publish-modal'
};

angular.module('exportbuilder.publish.constants', [])
    .constant('ExportBuilderPublishConstants', ExportBuilderPublishConstants);